import { mobileDeviceFromUserAgent } from '@hivebrite/utils';
import { useLayoutEffect } from './useLayoutEffect';
import { preventScrollMobileSafari } from '../utils/preventScrollMobileSafari';
import { preventScrollStandard } from '../utils/preventScrollStandard';
let preventScrollCount = 0;
let restore;
export const usePreventScroll = ({ allowPinchZoom, isOpen, }) => {
    useLayoutEffect(() => {
        if (isOpen) {
            preventScrollCount += 1;
            if (preventScrollCount === 1) {
                if (mobileDeviceFromUserAgent.iOS()) {
                    restore = preventScrollMobileSafari({ allowPinchZoom });
                }
                else if (!mobileDeviceFromUserAgent.Android()) {
                    restore = preventScrollStandard();
                }
            }
            return () => {
                preventScrollCount -= 1;
                if (preventScrollCount === 0) {
                    restore === null || restore === void 0 ? void 0 : restore();
                }
            };
        }
        return undefined;
    }, [allowPinchZoom, isOpen]);
};
//# sourceMappingURL=usePreventScroll.js.map